<template>
    <div class="settings-customs">

        <div class="custom">
            <div class="page-header">
                <div class="right" v-show="$page.props.p['members.payments.make']">
                    <v-btn @click="openCustomsModal" color="primary" dark>
                        <v-icon small class="mr-2">mdi-plus</v-icon>
                        {{ $page.props.lang.addCustomField || "Add custom field" }}
                    </v-btn>
                </div>
            </div>
            <v-dialog
            v-model="customsModal" content-class="customs-modal"
            max-width="500px">
                <v-card>
                    <div class="modal-header">
                        <h4 class="modal-headline">{{ $page.props.lang.addCustomField || "Add custom field" }}</h4>
                        <div class="tools">
                            <v-btn icon @click="customsModal = false"><v-icon>mdi-close</v-icon></v-btn>
                        </div>
                    </div>
                    <v-card-text>
                        <v-container>
                            <div class="fields">
                                <div class="grid">
                                    <p class="custom-label">{{ $page.props.lang.label || 'Label' }}</p>
                                    <v-text-field v-model="newCustom.label"
                                    outlined dense
                                    :error-messages="responseErrors.label" @focus="responseErrors.label=''"></v-text-field>
                                    <p class="custom-label">{{ $page.props.lang.type || 'Type' }}</p>
                                    <v-select outlined dense
                                    v-model="newCustom.type"
                                    :items="customTypes" @change="checkTypeRequired"
                                    item-text="title"
                                    item-value="value"
                                    :error-messages="responseErrors.type" @focus="responseErrors.type=''"></v-select>
                                    <v-checkbox v-model="newCustom.is_req"
                                    v-show="requiredCustomAvailable"
                                    :label="$page.props.lang.required || 'Is required'" 
                                    hide-details></v-checkbox>
                                </div>
                            </div>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="regular" @click="customsModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                <v-btn @click="saveMemberCustoms" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                            </v-card-actions>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            
            <div class="table-container">
                <v-data-table
                :headers="customsHeaders"
                :items="customsData"
                :page.sync="tablePage"
                @page-count="tablePageCount = $event"
                item-key="item.id"
                mobile-breakpoint="0"
                :items-per-page="itemsPerPage"
                hide-default-footer>
                    <template v-slot:item.label="{ item }">
                        {{ item.label }}
                    </template>
                    <template v-slot:item.type="{ item }">
                        {{ item.type }}
                    </template>
                    <template v-slot:item.is_req="{ item }">
                        {{ item.is_req===1 ? $page.props.lang.yes || 'Yes' : $page.props.lang.no || 'No' }}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn @click="openDeleteCustomModal(item)" :id="'delete' + item.id" class="delete-icon" icon>
                            <v-icon>mdi-trash-can-outline</v-icon>
                            <v-tooltip :activator="'#delete'+ item.id" bottom open-delay="500">
                                <span>{{$page.props.lang.deleteCustom || "Delete"}}</span>
                            </v-tooltip>
                        </v-btn>
                    </template>
                </v-data-table>
            </div>

            <v-pagination v-model="tablePage" :length="tablePageCount" class="front-paginate"></v-pagination>

        </div>

        <ConfirmDelete :open="deleteCustomModal" @no="deleteCustomModal = false" @yes="deleteCustom"></ConfirmDelete>
    
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import SettingsLayout from '@/js/Layouts/SettingsLayout'
import ConfirmDelete from '@/js/Components/ConfirmDelete'
import EventBus from '@/js/eventbus'

export default {
    layout: (h, page) => {
      return h(AppLayout, [
        h(SettingsLayout, [page]),
      ])
    },
    metaInfo() {
        return {
            title: this.$page.props.lang.title || "Custom Fields"
        }
    },
    components: {
        ConfirmDelete
    },
    props: {
        lang: Object,
        customs: Array,
    },
    data() {
        return {
            customsData: this.customs,
            customsHeaders: [
                {text: this.lang.label || 'Label', value: 'label', align: 'start'},
                {text: this.lang.type || 'Type', value: 'type', align: 'center', sortable: false},
                {text: this.lang.required || 'Is required', value: 'is_req', align: 'center', sortable: false},
                {value: 'action', align: 'end', sortable: false}
            ],
            colors: [
                '#4CAF50', //green
                '#2196F3', //blue
                '#9C27B0', //purple
                '#607D8B', //blue-grey
                '#FF5722', //deep-orange
                '#CDDC39', //lime
            ],
            tablePageCount: 0,
            itemsPerPage: 10,
            tablePage: 1,
            customsModal: false,
            customTypes: [
                { title: 'Text', value: 'text'},
                { title: 'Number', value: 'number'},
                { title: 'Decimal', value: 'decimal'},
                { title: 'Date', value: 'date'},
                { title: 'Boolean', value: 'boolean'},
            ],
            newCustom: {
                is_req: false
            },
            deleteCustomModal: false,
            customForDeleteId: null,
            requiredCustomAvailable: true,
            times: [
                {value: 15, text: '00:15'},
                {value: 30, text: '00:30'},
                {value: 45, text: '00:45'},
                {value: 60, text: '01:00'},
                {value: 75, text: '01:15'},
                {value: 90, text: '01:30'},
                {value: 105, text: '01:45'},
                {value: 120, text: '02:00'},
                {value: 135, text: '02:15'},
                {value: 150, text: '02:30'},
                {value: 165, text: '02:45'},
                {value: 180, text: '03:00'}
            ],
            responseErrors: {}
        }
    },
    watch: {
        customs(value) {
            this.customsData = value
        }
    },
    methods: {
        openCustomsModal() {
            this.newCustom = { is_req: false }
            this.customsModal = true
        },
        checkTypeRequired() {
            if (this.newCustom.type==='boolean') {
                this.requiredCustomAvailable = false
            } else {
                this.requiredCustomAvailable = true
            }
        },
        saveMemberCustoms() {
            this.responseErrors = {}
            axios.post('/backoffice/settings/saveMemberCustoms', this.newCustom)
                .then(response => {
                    if (response.data.status==="OK") {
                        this.customsModal = false
                        this.requiredCustomAvailable = true
                        this.$inertia.reload({only:['customs']})
                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    })
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                })
        },
        openDeleteCustomModal(item) {
            this.deleteCustomModal = true
            this.customForDeleteId = item.id
        },
        deleteCustom() {
            axios.post('/backoffice/settings/deleteCustom', {id: this.customForDeleteId})
                .then(response => {
                    if (response.data.status==="OK") {
                        this.deleteCustomModal = false
                        this.$inertia.reload({only:['customs']})
                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    })
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                })
        },
    }
}
</script>